<template>
  <div class="partnership">
    <partnership-flow :partner="$route.params.partner" />
    <illustration-mosaic />
  </div>
</template>

<script>
export default {
  name: 'partnership'
}
</script>

<style lang="scss" scoped>
.partnership {
  display: flex;
  justify-content: space-between;
  min-height: 100vh;
  background: $login-background;

  & > .illustration-mosaic {
    display: none;
  }

  @media screen and (min-width: 768px) {
    & > .illustration-mosaic {
      display: inline-flex;
    }
  }
}
</style>
